
export const DEFAULT_GROUP_ID = -1;

export default DEFAULT_GROUP_ID;
